import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";

// Read-only, line-by-line labeled field for LOCKED / immutable values (e.g. a part's
// donor-truck traceability). ONE shared layout so every "locked source" block — the
// Identify & Completion "Vehicle identity" donor block and the Part Detail "Source truck"
// panel — stays visually identical and can never drift apart. Full-width value box (no
// cramped tiles / truncation across normal values), lock icon, mono option for codes/VINs.
export function LockedField({ label, value, mono = false, testid }) {
  return (
    <div data-testid={testid}>
      <Label className="text-xs font-bold uppercase tracking-wider text-slate-500">{label}</Label>
      <div className={`w-full rounded-lg border border-slate-200 bg-slate-50 min-h-[2.75rem] px-3 py-2 mt-1.5 flex items-center gap-2 text-sm ${value ? "text-slate-900" : "text-slate-400"} ${mono ? "font-mono" : "font-medium"}`}>
        <Lock className="w-3.5 h-3.5 text-slate-300 shrink-0" />
        <span className="break-all">{value || "—"}</span>
      </div>
    </div>
  );
}
